import type { FunctionComponent } from 'react'
import { NullComponent } from '@ztechapps/webui.util'
import { BackButton } from './buttons/BackButton'
import { CancelCheckoutButton } from './buttons/CancelCheckoutButton'
import { ConfirmOrderButton } from './buttons/ConfirmOrderButton'
import { PaymentMethodButton } from './buttons/PaymentMethodButton'
import { PaymentMethodPanel } from './panels/PaymentMethodPanel'
import { ShippingRatePanel } from './panels/ShippingRatePanel'
import { ShippingRatePanelEmptyResult } from './panels/ShippingRatePanel/ShippingRatePanelEmptyResult'

export type Components = {
  itemPanel: FunctionComponent
  backButton: FunctionComponent
  confirmOrderButton: FunctionComponent
  cancelCheckoutButton: FunctionComponent
  paymentMethodPanel: FunctionComponent
  emailLink: FunctionComponent
  paymentMethodButton: FunctionComponent
  shippingRateEmptyResult: FunctionComponent
  shippingRatePanel: FunctionComponent
  paymentButton: FunctionComponent
}

export const defaultComponents: Components = {
  //item panel ad sub-components
  itemPanel: NullComponent,

  //shipping rate panels and sub-components
  shippingRatePanel: ShippingRatePanel,
  shippingRateEmptyResult: ShippingRatePanelEmptyResult,

  //payment method panel and sub-components
  paymentMethodPanel: PaymentMethodPanel,

  //button actions for each step
  backButton: BackButton,
  paymentMethodButton: PaymentMethodButton,
  confirmOrderButton: ConfirmOrderButton,
  cancelCheckoutButton: CancelCheckoutButton,
  paymentButton: NullComponent,

  //other components
  emailLink: NullComponent,
}
